
import { useState, useCallback, useRef } from 'react';
import { medicationApiService, MedicationSearchResult } from '@/services/medicationApi';

export function useMedicationSearch() {
  const [searchResults, setSearchResults] = useState<MedicationSearchResult[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState<string | null>(null);
  const debounceRef = useRef<NodeJS.Timeout>();

  const searchMedications = useCallback(async (query: string) => {
    console.log('🎯 HOOK: searchMedications called');
    console.log('🎯 Query received in hook:', JSON.stringify(query));
    console.log('🎯 Query type:', typeof query);
    console.log('🎯 Query length:', query.length);
    console.log('🎯 Current state - isSearching:', isSearching);
    console.log('🎯 Current state - searchResults length:', searchResults.length);
    
    // Clear previous debounce
    if (debounceRef.current) {
      console.log('🎯 Clearing previous debounce timer');
      clearTimeout(debounceRef.current);
    }

    // Clear results for very short queries
    if (query.length < 2) {
      console.log('🎯 Query too short, clearing state');
      setSearchResults([]);
      setIsSearching(false);
      setSearchError(null);
      return;
    }

    console.log('🎯 Setting isSearching to true');
    setIsSearching(true);
    setSearchError(null);

    // Debounce the API call
    debounceRef.current = setTimeout(async () => {
      console.log('🎯 Debounce timer fired, calling API service');
      console.log('🎯 About to call medicationApiService.searchMedications with:', JSON.stringify(query));
      
      try {
        console.log('🎯 Calling API service...');
        const results = await medicationApiService.searchMedications(query);
        console.log('🎯 API service returned results:', results);
        console.log('🎯 Number of results received:', results.length);
        console.log('🎯 Results details:', JSON.stringify(results, null, 2));
        
        console.log('🎯 Setting search results in state...');
        setSearchResults(results);
        console.log('🎯 Search results set successfully');
        
      } catch (error) {
        console.error('🎯 ERROR in hook:', error);
        console.error('🎯 Error name:', error instanceof Error ? error.name : 'Unknown');
        console.error('🎯 Error message:', error instanceof Error ? error.message : 'Unknown error');
        console.error('🎯 Error stack:', error instanceof Error ? error.stack : 'No stack trace');
        
        console.log('🎯 Setting error state...');
        setSearchError('Failed to search medications. Please try again.');
        setSearchResults([]);
        
      } finally {
        console.log('🎯 Setting isSearching to false');
        setIsSearching(false);
        console.log('🎯 Search process completed');
      }
    }, 300);

    console.log('🎯 Debounce timer set, waiting 300ms...');
  }, []);

  const clearSearch = useCallback(() => {
    console.log('🎯 clearSearch called');
    if (debounceRef.current) {
      console.log('🎯 Clearing debounce timer in clearSearch');
      clearTimeout(debounceRef.current);
    }
    console.log('🎯 Clearing all search state');
    setSearchResults([]);
    setIsSearching(false);
    setSearchError(null);
  }, []);

  return {
    searchResults,
    isSearching,
    searchError,
    searchMedications,
    clearSearch
  };
}
